/* eslint-disable @typescript-eslint/no-explicit-any */

import { supabase } from '@/integrations/supabase/client';
import { calculatePaymentTotals } from '@/utils/payment/paymentCalculations';

/**
 * Create a checkout session with Stripe via Supabase Edge Function
 * @param options Checkout session configuration
 * @returns Promise with the checkout session data
 */
export const createCheckoutSession = async (options: any) => {
  try {
    const grossCalculationResult: any = calculatePaymentTotals(options.products, options?.paymentMethod);
    console.log('grossCalculationResult',grossCalculationResult);

    const updatedOptions: any = {
      ...options,
      subtotal: grossCalculationResult?.subtotal,
      processingFee: grossCalculationResult?.processingFee?.toFixed(2),  // usd to cents
      total: grossCalculationResult?.total,
      showProcessingFee: grossCalculationResult?.showProcessingFee,
    };
    console.log('options',updatedOptions);
    // return;
    const { data, error } = await supabase.functions.invoke('create-payment', {
      body: updatedOptions
    });

    if (error) {
      console.error('Error creating checkout session:', error);
      throw new Error(error.message || 'Failed to create checkout session');
    }
    
    if (!data || !data.checkoutUrl) {
      console.error('Invalid response from create-payment function:', data);
      throw new Error('Invalid response from payment service');
    }

    return data;
  } catch (err) {
    console.error('Error in createCheckoutSession:', err);
    throw err;
  }
};
